import cookies from 'js-cookie'
import { IntlProvider } from 'react-intl'

import Locales from './locales'

const Localisation = ({ children }) => {
  const showOnlyKeys = cookies.get('disable-translations') === 'true'

  // Ignore the error if we're disabling translations
  const handleError = () => {}

  return (
    <IntlProvider
      locale="en-GB"
      onError={showOnlyKeys ? handleError : undefined}
      messages={showOnlyKeys ? {} : Locales['en-GB'].messages}
    >
      {children}
    </IntlProvider>
  )
}

export default Localisation
